const service = function (
	$auth, 
	$http, 
	$q,
	$rootScope, 
	$state, 
	_,
	api, 
	Basket, 
	Http,
	Invoice,
	Session, 
	Affiliate,
) {
	'ngInject'

	var service = this;

	this.session = () => Session.get('customer');
	this.get = () => Session.get('customer');

	this.update = (id, data) => {
		return $http.put(api+'/v1/customer/'+id, data).then(res => {
			return $http.get(api+'/v1/customer').then(res => {
				Session.set('customer', res.data);
				$rootScope.$broadcast('CUSTOMER_CHANGED');
				return $q.resolve();
			})
		}).catch(function(err) {
			$auth.logout().then(function() {
				$state.go('login', {});
			});
		});
	}

	this.create = () => {
		return $http.post(api+'/v1/customer').then(res => {
			return $http.get(api+'/v1/customer').then(res => {
				Session.set('customer', res.data);
				$rootScope.$broadcast('CUSTOMER_CHANGED');
				return $q.resolve();
			})
		}).catch(err => {
			$auth.logout().then(() => {
				$state.go('login', {});
			});
		});
	}

	this.saveEvaluation = (data) => Http.post('/v1/customer/nps', 'POST', data);

	this.flush = () => {
		Affiliate.get();
		Basket.flush();
		Invoice.flush();
		Session.remove('customer');
		$rootScope.$broadcast('CUSTOMER_CHANGED');
	}

	
}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/customer.service.js